import Numbers from "./components/Numbers.jsx";
import AreaChart from "./components/AreaChart.jsx";
import { latestDonationsColumns } from "./components/tablesColumns.jsx";
import GeneralReport from "./components/GeneralReport.jsx";
import { Card, ErrorAlert, Header, Table, useCanShow } from "@";
import { useStatisticDataQuery } from "./utils/queries.js";

const Index = () => {
  const { data, isLoading, isError, refetch } = useStatisticDataQuery();
  const canShowStatistics = useCanShow("statistics");
  const { numbers, latestDonations, totalDonationsChart } = data || {};

  return (
    <>
      {/* Page header */}
      <Header links={[]} title="إحصاءات وبيانات" />
      <ErrorAlert reload={refetch} show={isError} />

      {/* Page content */}
      <main>
        {/* Numbers cards */}
        <Numbers numbers={numbers} />

        {/* Donations Chart */}
        <AreaChart data={totalDonationsChart} />

        {/* General statistics report */}
        {canShowStatistics && <GeneralReport />}

        {/* Latest donations table */}
        <Card title="أحدث التبرعات" className="print:hidden">
          <Table
            localPg
            isLoading={isLoading}
            data={latestDonations}
            columns={latestDonationsColumns}
          />
        </Card>
      </main>
    </>
  );
};

export default Index;
